/* shim_v2 */
/*
 * Mission CTA click tracking — consumer shim.
 *
 * Captures clicks on any element with [data-mission-cta] (header + drawer
 * nav, dual-hero CTA) and publishes 'mission_click' events for outbound
 * traffic to mymission.ai.
 *
 * Routes through theme/assets/cta-tracking-core.js for the shared chain
 * (consent gate, pointerdown/click/auxclick capture, dedupe, 3-sink publish)
 * per rules/canonical_centralization.md.
 *
 * theme.liquid MUST load cta-tracking-core.js BEFORE this file.
 *
 * Dedupe key: cta_variant + pathname (mission CTAs aren't tied to products;
 * the variant alone tells us which CTA location fired).
 */
(function () {
  'use strict';

  if (!window.NCCtaTracking) {
    if (window.console) console.warn('[mission-tracking] cta-tracking-core.js not loaded; tracker disabled');
    return;
  }

  window.NCCtaTracking.install({
    attr: 'data-mission-cta',
    eventName: 'mission_click',
    idempotencyFlag: '__ncMissionTrackingLoaded',
    logPrefix: 'mission-tracking',
    dedupeKeyFn: function (el) {
      return el.getAttribute('data-mission-cta') + '|' + window.location.pathname;
    },
  });
})();
